export type SatelliteRaster = {
  date: string | null;
  url: string | null;
  heterogeneity: number | null;
};

export type SatellitePlotInfo = {
  plotId: number;
  plotName?: string;
  rasters: SatelliteRaster[] | null;
  checked: boolean;
  coordinates?: number[][];
};

export type SatelliteColorbar = {
  min: number;
  max: number;
  color: string[];
  stops?: number[];
};

export type SatelliteImageryIndex = 'NDVI' | 'LAI' | 'NDWI' | 'RGB';

export const SATELLITE_IMAGERY_INDEXES: SatelliteImageryIndex[] = [
  'NDVI',
  'LAI',
  'NDWI',
  'RGB',
];

export function isSatelliteImageryIndex(
  value: string | undefined
): value is SatelliteImageryIndex {
  return SATELLITE_IMAGERY_INDEXES.includes(value as SatelliteImageryIndex);
}
